var StitchUserIdentity = (function () {
    function StitchUserIdentity(id, providerType) {
        this.id = id;
        this.providerType = providerType;
    }
    return StitchUserIdentity;
}());
export default StitchUserIdentity;
//# sourceMappingURL=StitchUserIdentity.js.map